import { getLuminance } from "@mui/material/styles";
import type { ArtifactThemeMode } from "@entrilia/shared/artifactRuntime/protocol";
import type { SmartViewArtifactMeasuredColour } from "../../../../../api/types/smartViewArtifactsTypes";

const DARK_LUMINANCE_LIMIT = 0.18;

export const getPictureMode = (colours: SmartViewArtifactMeasuredColour[]): ArtifactThemeMode => {
  const firstPicture = colours.filter(({ picture }) => picture === 1);
  const totalShare = firstPicture.reduce((sum, { share }) => sum + share, 0);
  if (totalShare === 0) {
    return "light";
  }
  const luminanceSum = firstPicture.reduce((sum, { hex, share }) => sum + getLuminance(`#${hex}`) * share, 0);
  return luminanceSum / totalShare < DARK_LUMINANCE_LIMIT ? "dark" : "light";
};
